import { render, staticRenderFns } from "./hqStuHealthKnowledge.vue?vue&type=template&id=04b57672&scoped=true"
import script from "./hqStuHealthKnowledge.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b57672",
  null
  
)

export default component.exports